<template>
  <div>
    <v-tabs v-model="active" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab ripple :key="'customer'" :href="'#customer'">{{ $t('Customer') }}</v-tab>
      <v-tab ripple :key="'supplier'" :href="'#supplier'">{{ $t('Supplier') }}</v-tab>
    </v-tabs>

    <div v-if="active == 'customer'">
      <customer></customer>
    </div>
    <div v-if="active == 'supplier'">
      <supplier></supplier>
    </div>
  </div>
</template>

<script>
import customer from './customerCRM.vue'
import supplier from './supplierCRM.vue'
export default {
  components: {
    customer,
    supplier
  },
  data() {
    return {
      active: 'customer'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/scgallrent/main.vue